class MobileMenuKeyNav {
  constructor(params) {
    this.setupComplete = false
    this.events(params)
  }

  events(params) {
    const paramsArray = [].concat(params)
    paramsArray.forEach((p) => this.initMobileMenuKeyNav(p))
  }

  initMobileMenuKeyNav({ targetSelector, buttonSelector }) {
    this.menu = document.querySelector(targetSelector)
    this.toggleButton = document.querySelector(buttonSelector)
    this.toggleButton.addEventListener("keydown", this.handleToggleButtonKeydown.bind(this))

    this.updateToggleButtonAttributes()

    this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    this.menuItemsWithSubmenu = this.menu.querySelectorAll(".menu-item-has-children")

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          const isMenuOpen = this.toggleButton.classList.contains("open")
          if (isMenuOpen && !this.setupComplete) {
            this.setupFocusTrap()
            this.setupComplete = true
          }
        }
      })
    })

    observer.observe(this.toggleButton, { attributes: true })
    this.setupSubmenuAriaAttributes()
  }
  updateToggleButtonAttributes() {
    this.toggleButton.setAttribute("tabindex", "0")
    this.toggleButton.setAttribute("role", "button")
    this.toggleButton.setAttribute("aria-label", "Toggle mobile menu")
  }
  setupFocusTrap() {
    const focusableElements = this.menu.querySelectorAll(this.focusableElements)
    this.firstFocusableElement = focusableElements[0]
    this.lastFocusableElement = focusableElements[focusableElements.length - 1]
    this.firstFocusableElement.focus()

    this.menu.addEventListener("keydown", (e) => {
      if (e.key === "Tab") {
        if (e.shiftKey) {
          /* shift + tab */ if (document.activeElement === this.firstFocusableElement) {
            e.preventDefault()
            this.lastFocusableElement.focus()
          }
        } /* tab */ else {
          if (document.activeElement === this.lastFocusableElement) {
            e.preventDefault()
            this.toggleMenu()
          }
        }
      } else if (e.key === "Escape") {
        if (this.toggleButton.classList.contains("open")) {
          this.toggleMenu()
        }
      }
    })
  }

  setupSubmenuAriaAttributes() {
    // this.menuItemsWithSubmenu.forEach((item) => {
    //   const toggleLink = item.querySelector("a");
    //   const submenu = item.querySelector(".sub-menu");
    //   if (toggleLink && submenu) {
    //     toggleLink.setAttribute("aria-haspopup", "true");
    //     toggleLink.setAttribute("aria-expanded", "false");
    //     submenu.setAttribute("aria-hidden", "true");
    //     toggleLink.addEventListener("click", (e) => {
    //       e.preventDefault();
    //       const isExpanded =
    //         toggleLink.getAttribute("aria-expanded") === "true";
    //       toggleLink.setAttribute("aria-expanded", String(!isExpanded));
    //       submenu.setAttribute("aria-hidden", String(isExpanded));
    //       // Add logic here to actually show/hide the submenu, if not already handled elsewhere
    //     });
    //   }
    // });
  }

  handleToggleButtonKeydown(e) {
    if (e.key === "Enter" || e.key === " ") {
      // ' ' represents the Space key
      e.preventDefault()
      this.toggleMenu()
    }
  }

  toggleMenu() {
    const isMenuOpen = this.toggleButton.classList.contains("open")
    this.toggleButton.setAttribute("aria-expanded", !isMenuOpen)
    this.toggleButton.click()
  }
}
export { MobileMenuKeyNav }
